import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class ProductionChargeService extends GenericService {
  constructor() {
    super('/production_charges', axiosInstance);
  }
}

export default new ProductionChargeService(); 